import { FC, ReactNode } from 'react';
import { Card, CardContent } from '@shared/shared-shadcn-ui';
import ExportedImage from 'next-image-export-optimizer';
import { StaticImageData } from 'next/image';
import Link from 'next/link';

type Properties = {
  imageBrochure: string | StaticImageData;
  label: ReactNode;
  link: string;
};

const ValuableResourceCard: FC<Properties> = ({
  imageBrochure,
  label,
  link,
}: Properties) => {
  return (
    <Card className="rounded-[14px] drop-shadow-[0_0_6px_rgba(0,0,0,0.16)]">
      <CardContent className="p-0">
        <div className="flex gap-x-6">
          <ExportedImage
            src={imageBrochure}
            width={106}
            height={164}
            alt="valuable resource"
            className="rounded-l-[14px]"
          />
          <Link
            href={link}
            target="_blank"
            className="flex items-center justify-center text-[18px] lg:text-[20px] text-[#007297] font-bold font-benton-sans"
          >
            {label}
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export { ValuableResourceCard };
